export default {
  data() {
    return {
      autoComplete: false,
    }
  },
  mounted() {
    this.initAutoComplete()
  },
  beforeDestroy() {
    document.removeEventListener(
      'animationstart',
      this.eventAnimationAutoFill,
      true
    )

    document.removeEventListener('input', this.eventInputAutoFill, true)
  },
  methods: {
    /** se sobreescribe en el componente que se va a agregar el mixin para definir logica segun form */
    commonAutoComplete(element) {},
    eventAnimationAutoFill(event) {
      if (event.animationName === 'onautofillstart') {
        this.autoComplete = true
      } else {
        this.autoComplete = false
      }

      this.commonAutoComplete(event.target)
    },
    eventInputAutoFill(event) {
      if (event.inputType === 'insertReplacementText' || !('data' in event)) {
        this.autoComplete = true
      } else {
        this.autoComplete = false
      }

      this.commonAutoComplete(event.target)
    },
    /** https://github.com/matteobad/detect-autofill/blob/master/src/detect-autofill.js */
    initAutoComplete() {
      document.addEventListener(
        'animationstart',
        this.eventAnimationAutoFill,
        true
      )

      document.addEventListener('input', this.eventInputAutoFill, true)
    },
  },
}
